import { useState, useEffect, useCallback, useRef } from "react";
import "./styles.css";
import { useLang } from "../../context/langProvider";
import { useDispatch, useSelector } from 'react-redux';
import { updateProjectField, addProjectPhoto, removeProjectPhoto, setProjectVideo, sendProject } from '../../redux/actions/projectActions';
import { saveBlob, getBlob, deleteBlob } from '../../utils/idbBlobStorage';
import AddressForm from "../AddressForm";
//import { useNavigate } from "react-router-dom";

export default function JobModalForm({ onClose, initialService }) {
    const [serviceName, setServiceName] = useState("");
    const [services, setServices] = useState([]);
    const [selectedService, setSelectedService] = useState(null);
    const [idServiceParent, setIdServiceParent] = useState(initialService?.id || null);
    const [navigationPath, setNavigationPath] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formProject, setFormProject] = useState(false);
    const dispatch = useDispatch();

    const project = useSelector(state => state.project.projectToPost);
    const { lang } = useLang();

    const [videoUrl, setVideoUrl] = useState(null);
    const [photoUrls, setPhotoUrls] = useState([]);
    const videoInputRef = useRef(null);
    const photoInputRef = useRef(null);
    //const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL;

    const handleAddressSelect = (address) => {
    console.log("Adresse choisie :", address);
    // ici => envoyer au backend
  };
    const refreshServices = useCallback((id) => {
        const url = id
            ? `${apiUrl}/api/services/${id}/?lang=${lang}&option=getChildren`
            : `${apiUrl}/api/services?lang=${lang}`;
        setLoading(true);

        return fetch(url, { method: "GET" })
            .then((res) => res.json())
            .then((data) => setServices(data))
            .catch((err) => console.error("Erreur chargement services :", err))
            .finally(() => setLoading(false));
    }, [lang, apiUrl]);

    // Initialisation du breadcrumb et chargement auto
    useEffect(() => {
        if (initialService) {
            // Si le service a un parent connu → Services / Parent / Service
            if (initialService.parent) {
                setNavigationPath([
                    { id: initialService.parent.idService, name: initialService.parent.nameService },
                    { id: initialService.id, name: initialService.name }
                ]);
                setIdServiceParent(initialService.id);
                refreshServices(initialService.id);
            } else {
                // Service principal → Services / [Nom]
                setNavigationPath([
                    { id: initialService.id, name: initialService.name }
                ]);
                setIdServiceParent(initialService.id);
                refreshServices(initialService.id);
            }
        } else {
            // Aucun service en entrée → liste racine
            refreshServices(null);
        }
    }, [initialService, refreshServices]);

    useEffect(() => {
        let canceled = false;

        const loadVideo = async () => {
            if (!project.videoPresentationProject) {
                setVideoUrl(null);
                return;
            }
            const blob = await getBlob(project.videoPresentationProject);
            if (!blob || canceled) return;
            const url = URL.createObjectURL(blob);
            setVideoUrl(url);
        };

        loadVideo();

        return () => {
            canceled = true;
            if (videoUrl) URL.revokeObjectURL(videoUrl);
        };
    }, [project.videoPresentationProject]);

    useEffect(() => {
        let canceled = false;

        const loadPhotos = async () => {
            const blobs = await Promise.all(project.photosProject.map(key => getBlob(key)));
            if (canceled) return;
            const urls = blobs.map(blob => blob ? URL.createObjectURL(blob) : null);
            setPhotoUrls(urls);
        };

        loadPhotos();

        return () => {
            canceled = true;
            photoUrls.forEach(url => url && URL.revokeObjectURL(url));
        };
    }, [project.photosProject]);

    const handleVideoChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const key = await saveBlob(file);
        dispatch(setProjectVideo(key));
    };

    const handlePhotoChange = async (e) => {
        const files = Array.from(e.target.files);
        for (const file of files) {
            const key = await saveBlob(file);
            dispatch(addProjectPhoto(key));
        }
    };

    const handleDeleteVideo = async () => {
        if (!project.videoPresentationProject) return;
        await deleteBlob(project.videoPresentationProject);
        dispatch(setProjectVideo(null));
        if (videoInputRef.current) {
            videoInputRef.current.value = "";
        }
    };

    const handleDeletePhoto = async (index) => {
        const key = project.photosProject[index];
        if (!key) return;
        await deleteBlob(key);
        dispatch(removeProjectPhoto(index));
        if (photoInputRef.current) {
            photoInputRef.current.value = "";
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        dispatch(updateProjectField(name, type === 'checkbox' ? checked : value));
    };

    return (
        <div className="jobModalOverlay">
            <div className="jobModal">
                <button className="jobModalClose" onClick={onClose}>×</button>
                {!formProject && (<>
                    <div className="jobModalHeader">
                        <h2>{navigationPath.length > 0
                            ? navigationPath[navigationPath.length - 1].name
                            : "Demander un service"}</h2>
                        <input
                            className="inputSearchService"
                            type="text"
                            value={serviceName}
                            onChange={(e) => setServiceName(e.target.value)}
                            placeholder="Que recherchez-vous ?"
                        />

                        {navigationPath.length > 0 && !loading && (
                            <div className="breadcrumb">
                                <span
                                    className="breadcrumb-link"
                                    onClick={() => {
                                        setNavigationPath([]);
                                        setIdServiceParent(null);
                                        refreshServices(null);
                                    }}
                                >
                                    Services
                                </span>
                                {navigationPath.map((step, index) => {
                                    const isLast = index === navigationPath.length - 1;
                                    return (
                                        <span key={step.id}>
                                            {" / "}
                                            {isLast ? (
                                                <span className="breadcrumb-current">{step.name}</span>
                                            ) : (
                                                <span
                                                    className="breadcrumb-link"
                                                    onClick={() => {
                                                        const newPath = navigationPath.slice(0, index + 1);
                                                        setNavigationPath(newPath);
                                                        setIdServiceParent(step.id);
                                                        refreshServices(step.id);
                                                    }}
                                                >
                                                    {step.name}
                                                </span>
                                            )}
                                        </span>
                                    );
                                })}
                            </div>
                        )}
                    </div>

                    {loading ? (
                        <div className="loader">
                            <div className="spinner"></div>
                            Chargement des services...
                        </div>
                    ) : (
                        <div className="services-container-selection">
                            {services.length > 0 && services.map((service) => (
                                <div key={service.idService} className="card-service-container-selection">
                                    <div
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (!service.isBookable) {
                                                setIdServiceParent(service.idService);
                                                setNavigationPath((prev) => [
                                                    ...prev,
                                                    { id: service.idService, name: service.nameService }
                                                ]);
                                                refreshServices(service.idService);
                                            } else {
                                                // setNavigationPath([]);
                                                // navigate("/demander-service/" + service.slugService + "/nb-hours");
                                                // onClose();
                                                setSelectedService(service);
                                                dispatch(updateProjectField("idService", service.idService));
                                                setFormProject(true);
                                            }
                                        }}
                                        className="card-service-selection"
                                    >
                                        <img
                                            src={`${apiUrl}/api/files/?categorie=services&file=${service.iconService}`}
                                            alt="icone service"
                                        />
                                        <span>{service.nameService}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </>)}
                {
                    formProject && (
                        <>
                            <div className="jobModalHeader">
                                <h2>Déposer un projet de service {selectedService.nameService}</h2>
                            </div>
                            <div className="jobModalContainer">
                                <form>
                                    <label htmlFor="titleProject">Titre du projet</label>
                                    <input
                                        type="text"
                                        name="titleProject"
                                        id="titleProject"
                                        value={project.titleProject}
                                        onChange={handleChange}
                                        
                                    />
                                    <label htmlFor="budgetProject">Budget du projet</label>
                                    <input
                                        type="number"
                                        name="budgetProject"
                                        id="budgetProjet"
                                        step="0.10"
                                        value={project.budgetProject}
                                        onChange={handleChange}
                                    />
                                    <AddressForm onSelect={handleAddressSelect}/>
                                    <label htmlFor="descriptionProject">Description du projet</label>

                                    <textarea
                                        name="descriptionProject"
                                        id="descriptionProject"
                                        value={project.descriptionProject}
                                        onChange={handleChange}
                                        rows={10}
                                    />

                                    <label>
                                        <input
                                            type="checkbox"
                                            name="isProfessionalProject"
                                            checked={project.isProfessionalProject}
                                            onChange={handleChange}
                                        /> Projet à titre professionnel
                                    </label>

                                    <div>
                                        <label>Vidéo de présentation du projet (Optionnel)</label>
                                        <label className="custom-file-upload">
                                            Sélectionner une vidéo
                                            <input
                                                type="file"
                                                accept="video/*"
                                                onChange={handleVideoChange}
                                                ref={videoInputRef}
                                                style={{display:"none"}}
                                            />
                                        </label>
                                        {videoUrl && (
                                            <div className="media-preview">
                                                <video controls src={videoUrl} />
                                                <button type="button" className="delete-button" onClick={handleDeleteVideo}>Supprimer la vidéo</button>
                                            </div>
                                        )}
                                    </div>

                                    <div>
                                        <label>Photos du projet</label>
                                        <label className="custom-file-upload">
                                            Ajouter des photos
                                            <input
                                                type="file"
                                                accept="image/*"
                                                multiple
                                                onChange={handlePhotoChange}
                                                ref={photoInputRef}
                                                style={{display:"none"}}
                                            />
                                        </label>
                                        <div className="photo-thumbs">
                                            {project.photosProject.map((key, idx) => {
                                                const url = photoUrls[idx];
                                                return url && (
                                                    <div key={key} className="photo-thumb">
                                                        <img src={url} alt={`photo-${idx}`} />
                                                        <button
                                                            type="button"
                                                            className="delete-photo"
                                                            onClick={() => handleDeletePhoto(idx)}
                                                        >
                                                            ×
                                                        </button>
                                                    </div>
                                                );
                                            })}

                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        className="submit-button"
                                        onClick={() => dispatch(sendProject())}
                                    >
                                        Enregistrer le projet
                                    </button>


                                    {/* Bouton submit à ajouter selon logique API */}
                                </form>
                            </div>
                        </>
                    )
                }
            </div>
        </div>
    );
}
